export default "__VITE_ASSET__CW4p0B1j__"